import { useEffect } from 'react';

import { pauseAllSkipContentSync, pauseSettingsSync, resumeAllSkipContentSync, resumeSettingsSync } from 'modules/settings-sync/subscriptions/listening';

export const useSkipContentSyncPause = () => {
  useEffect(() => {
    pauseAllSkipContentSync();
    return () => resumeAllSkipContentSync();
  }, []);
};

export const useSpecificSettingsSync = (keys: string[]) => {
  useEffect(() => {
    pauseSettingsSync(keys);
    return () => resumeSettingsSync(keys);
  }, [keys]);
};
